import { isPwa } from 'owa-config';
import { PreviewPaneSelectionSource } from 'owa-sxs-store';

export default function getJsApiSessionOrigin(
    selectionSource: PreviewPaneSelectionSource,
    isEdit: boolean
): string {
    const applicationPart: string = isPwa() ? 'OWA-PWA' : 'OWA-WEB';
    const scenarioPart: string = isEdit ? 'SXS-EDIT' : 'SXS-VIEW';
    let sourcePart: string = '';

    switch (selectionSource) {
        case PreviewPaneSelectionSource.MailList:
            sourcePart = 'ML';
            break;
        case PreviewPaneSelectionSource.ConversationAttachmentWell:
            sourcePart = 'CAW';
            break;
        case PreviewPaneSelectionSource.ReadingPane:
            sourcePart = 'RP';
            break;
        case PreviewPaneSelectionSource.FilesHub:
            sourcePart = 'FH';
            break;
        case PreviewPaneSelectionSource.PhotoHub:
            sourcePart = 'PH';
            break;
        case PreviewPaneSelectionSource.GroupFilesHub:
            sourcePart = 'GFH';
            break;
        case PreviewPaneSelectionSource.ConsumerGroupFilesHub:
            sourcePart = 'CGF';
            break;
        case PreviewPaneSelectionSource.Deeplink:
            sourcePart = 'DL';
            break;
        case PreviewPaneSelectionSource.FileSuggestion:
            sourcePart = 'FS';
            break;
        case PreviewPaneSelectionSource.LinkSuggestion:
            sourcePart = 'LS';
            break;
        case PreviewPaneSelectionSource.ComposeDocLink:
            sourcePart = 'CDL';
            break;
        case PreviewPaneSelectionSource.ReadingPaneDocLink:
            sourcePart = 'RPDL';
            break;
        case PreviewPaneSelectionSource.FolderTree:
            sourcePart = 'FT';
            break;
        default:
            sourcePart = 'UNKNOWN';
    }

    return `${applicationPart}.${sourcePart}.${scenarioPart}`;
}
